import React from 'react';
import { Form } from 'react-bootstrap';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import FormLabel from 'v2/form/FormLabel/FormLabel';
import { FileFormFields } from 'v2/utils/drmFileUtils';
import ActivityAssociations from 'v2/common/Activity/ActivityAssociations';
import { ActivityAssociation } from 'v2/models';
import FileInput from 'v2/form/FileInput/FileInput';
import FileTypeDropdown from '../FileTypeDropdown';

interface FileFormProps {
  isLoading: boolean;
  defaultAssociations: ActivityAssociation[];
}

const FileForm = ({ isLoading, defaultAssociations }: FileFormProps) => {
  const { register, control, resetField } = useFormContext<FileFormFields>();
  const { file } = useWatch<FileFormFields>();

  return (
    <>
      <div>
        <FileInput
          control={control}
          file={file}
          resetField={resetField}
          disabled={isLoading}
        />
      </div>
      <div>
        <FormLabel label={`File Type`} required={false} />
        <FileTypeDropdown />
      </div>
      <div>
        <FormLabel label={`File Description`} required={false} />
        <Form.Control
          as="textarea"
          placeholder="File Description"
          rows={4}
          autoComplete="off"
          disabled={isLoading}
          {...register('description', { required: true })}
        />
      </div>
      <div>
        <Controller
          name="relationships"
          control={control}
          rules={{
            required: true,
          }}
          defaultValue={defaultAssociations}
          render={({ field: { onChange } }) => {
            return (
              <ActivityAssociations
                initialActivityAssociations={defaultAssociations}
                onChange={(values) => onChange(values)}
              />
            );
          }}
        />
      </div>
    </>
  );
};

export default FileForm;
